module.exports = __webpack_public_path__ + "img/wenzizhouxing.0e5453de.png";